var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { BigNumber } from "ethers";
import { createGlobalState } from "react-hooks-global-state";
import { getAssets, getDisplayAssets, VaultList, VaultVersionList, } from "../constants/constants";
import { DefiScoreTokenList, } from "../models/defiScore";
import { ERC20TokenList } from "../models/eth";
import { getAssetDecimals } from "../utils/asset";
import { AssetsList, } from "./types";
export var initialVaultAccounts = Object.fromEntries(__spreadArray(__spreadArray([], VaultVersionList), ["all"]).map(function (version) { return [
    version,
    Object.fromEntries(VaultList.map(function (option) { return [option, undefined]; })),
]; }));
export var initialState = {
    vaultData: Object.fromEntries(VaultList.map(function (vault) { return [
        vault,
        {
            status: "loading",
            deposits: BigNumber.from("0"),
            vaultLimit: BigNumber.from("0"),
            vaultBalanceInAsset: BigNumber.from("0"),
            vaultMaxWithdrawAmount: BigNumber.from("0"),
            asset: getAssets(vault),
            displayAsset: getDisplayAssets(vault),
            decimals: getAssetDecimals(getAssets(vault)),
            userAssetBalance: BigNumber.from("0"),
            maxWithdrawAmount: BigNumber.from("0"),
            error: null,
        },
    ]; })),
    v2VaultData: Object.fromEntries(VaultList.map(function (vault) { return [
        vault,
        {
            totalBalance: BigNumber.from(0),
            cap: BigNumber.from(0),
            decimals: getAssetDecimals(getAssets(vault)),
            asset: getAssets(vault),
            displayAsset: getDisplayAssets(vault),
            pricePerShare: BigNumber.from(0),
            round: 1,
            lockedBalanceInAsset: BigNumber.from(0),
            depositBalanceInAsset: BigNumber.from(0),
            userAssetBalance: BigNumber.from(0),
            withdrawals: {
                shares: BigNumber.from(0),
                round: 1,
            },
        },
    ]; })),
    prices: Object.fromEntries(AssetsList.map(function (asset) { return [asset, { price: 0.0, fetched: false }]; })),
    pendingTransactions: [],
    showConnectWallet: false,
    latestAPY: Object.fromEntries(VaultList.map(function (option) { return [option, { apy: 0.0, fetched: false }]; })),
    assetYieldsInfo: {
        fetched: false,
        data: Object.fromEntries(DefiScoreTokenList.map(function (token) { return [token, new Array(0)]; })),
    },
    gasPrice: "",
    desktopView: "grid",
    airdropInfo: undefined,
    tokenBalances: Object.fromEntries(ERC20TokenList.map(function (token) { return [
        token,
        { balance: BigNumber.from(0), fetched: false },
    ]; })),
    vaultAccounts: initialVaultAccounts,
};
export var useGlobalState = createGlobalState(initialState).useGlobalState;
//# sourceMappingURL=store.js.map